/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CreatePropertyDetailRequest,
  NotFoundErrorResponse,
  PropertyDetailApiResource,
  PropertyDetailsListApiResource,
  UnauthorizedErrorResponse,
  UpdatePropertyDetailRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiPropertyDetailCreateResponse201 = {
  data: PropertyDetailApiResource
  status: 201
}

export type postApiPropertyDetailCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyDetailCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyDetailCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyDetailCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiPropertyDetailCreateResponseSuccess = (postApiPropertyDetailCreateResponse201) & {
  headers: Headers;
};
export type postApiPropertyDetailCreateResponseError = (postApiPropertyDetailCreateResponse400 | postApiPropertyDetailCreateResponse401 | postApiPropertyDetailCreateResponse403 | postApiPropertyDetailCreateResponse409) & {
  headers: Headers;
};

export type postApiPropertyDetailCreateResponse = (postApiPropertyDetailCreateResponseSuccess | postApiPropertyDetailCreateResponseError)

export const getPostApiPropertyDetailCreateUrl = (propertyId: number,) => {


  

  return `/api/properties/${propertyId}/details`
}

export const postApiPropertyDetailCreate = async (propertyId: number,
    createPropertyDetailRequest: CreatePropertyDetailRequest, options?: RequestInit): Promise<postApiPropertyDetailCreateResponse> => {
  
  return customFetch<postApiPropertyDetailCreateResponse>(getPostApiPropertyDetailCreateUrl(propertyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPropertyDetailRequest,)
  }
);}


export type deleteApiPropertyDetailDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiPropertyDetailDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiPropertyDetailDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiPropertyDetailDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiPropertyDetailDeleteResponseSuccess = (deleteApiPropertyDetailDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiPropertyDetailDeleteResponseError = (deleteApiPropertyDetailDeleteResponse401 | deleteApiPropertyDetailDeleteResponse403 | deleteApiPropertyDetailDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiPropertyDetailDeleteResponse = (deleteApiPropertyDetailDeleteResponseSuccess | deleteApiPropertyDetailDeleteResponseError)

export const getDeleteApiPropertyDetailDeleteUrl = (propertyId: string,
    id: string,) => {


  

  return `/api/properties/${propertyId}/details/${id}`
}

export const deleteApiPropertyDetailDelete = async (propertyId: string,
    id: string, options?: RequestInit): Promise<deleteApiPropertyDetailDeleteResponse> => {
  
  return customFetch<deleteApiPropertyDetailDeleteResponse>(getDeleteApiPropertyDetailDeleteUrl(propertyId,id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type patchApiPropertyDetailUpdateResponse200 = {
  data: PropertyDetailApiResource
  status: 200
}

export type patchApiPropertyDetailUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type patchApiPropertyDetailUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type patchApiPropertyDetailUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type patchApiPropertyDetailUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type patchApiPropertyDetailUpdateResponseSuccess = (patchApiPropertyDetailUpdateResponse200) & {
  headers: Headers;
};
export type patchApiPropertyDetailUpdateResponseError = (patchApiPropertyDetailUpdateResponse400 | patchApiPropertyDetailUpdateResponse401 | patchApiPropertyDetailUpdateResponse403 | patchApiPropertyDetailUpdateResponse404) & {
  headers: Headers;
};

export type patchApiPropertyDetailUpdateResponse = (patchApiPropertyDetailUpdateResponseSuccess | patchApiPropertyDetailUpdateResponseError)

export const getPatchApiPropertyDetailUpdateUrl = (propertyId: string,
    id: string,) => {


  

  return `/api/properties/${propertyId}/details/${id}`
}

export const patchApiPropertyDetailUpdate = async (propertyId: string,
    id: string,
    updatePropertyDetailRequest: UpdatePropertyDetailRequest, options?: RequestInit): Promise<patchApiPropertyDetailUpdateResponse> => {
  
  return customFetch<patchApiPropertyDetailUpdateResponse>(getPatchApiPropertyDetailUpdateUrl(propertyId,id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePropertyDetailRequest,)
  }
);}


export type getApiPropertyDetailsListResponse200 = {
  data: PropertyDetailsListApiResource
  status: 200
}

export type getApiPropertyDetailsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyDetailsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyDetailsListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyDetailsListResponseSuccess = (getApiPropertyDetailsListResponse200) & {
  headers: Headers;
};
export type getApiPropertyDetailsListResponseError = (getApiPropertyDetailsListResponse401 | getApiPropertyDetailsListResponse403 | getApiPropertyDetailsListResponse404) & {
  headers: Headers;
};

export type getApiPropertyDetailsListResponse = (getApiPropertyDetailsListResponseSuccess | getApiPropertyDetailsListResponseError)

export const getGetApiPropertyDetailsListUrl = (propertyId: string,) => {


  

  return `/api/property/${propertyId}/details`
}

export const getApiPropertyDetailsList = async (propertyId: string, options?: RequestInit): Promise<getApiPropertyDetailsListResponse> => {
  
  return customFetch<getApiPropertyDetailsListResponse>(getGetApiPropertyDetailsListUrl(propertyId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


